export default "__VITE_ASSET__8ef25d08__"